<template>
  <div class="college">
    <div class="list-area">
      <div class="item"  v-for="(item, index) in videoList" :key="index" @click="toDetailPage(item)">
        <div class="class-img">
          <img :src="item.previewImg"  :alt="item.title"  width="100%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoList: [
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/downloadApp.png',
          title: '第一课 如何下载钱收收APP',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E4%B8%8B%E8%BD%BD%E6%B3%A8%E5%86%8C.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/searchProduct.png',
          title: '第二课 如何在钱收收搜索商品',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E6%90%9C%E7%B4%A2%E5%95%86%E5%93%81.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/buyAndSaveMoney.png',
          title: '第三课 如何在钱收收自购省钱',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E8%87%AA%E8%B4%AD%E7%9C%81%E9%92%B1.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/shareProduct.png',
          title: '分享商品',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E5%88%86%E4%BA%AB%E5%95%86%E5%93%81.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/invitation.png',
          title: '如何推广邀请',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E6%8E%A8%E5%B9%BF%E9%82%80%E8%AF%B7.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/VideoCover/seeEarnings.png',
          title: '如何在钱收收查看订单和收益',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E6%9F%A5%E7%9C%8B%E8%AE%A2%E5%8D%95%E5%92%8C%E6%94%B6%E7%9B%8A0708.mp4'
        },
        {
          previewImg: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2/%E5%A6%82%E4%BD%95%E7%BE%8E%E5%9B%A2%E7%BA%A2%E5%8C%85.png',
          title: '如何使用美团红包',
          videoSrc: 'https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/video/tutorial.mp4'
        },
      ]
    }
  },
  computed: {

  },
  methods: {
    /**
     * 去播放页面
     */
    toDetailPage(item) {
      this.$router.push({
        path: '/h5/college/videoPlayer',
        query: item
      })
    }
  },
}
</script>

<style scoped lang="less">
.college {
  overflow: hidden;
  background: #eeeeee;
  font-size: 28px;
  .list-area {
    margin: 20px;
    :nth-child(n) {
      margin-bottom: 30px;
    }
    :nth-last-child(1) {
      margin-bottom: 0;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      .class-img {
        width: 100%;
      }
    }
  }
}
</style>
